import { store, getContext } from "@wordpress/interactivity";

const { state } = store("filterable-projects", {
  state: {
    get filteredProjects() {
      const { projects, activeTerm, activeStato, searchQuery } = state;
      const q = searchQuery.trim().toLowerCase();

      return projects.filter((p) => {
        if (activeTerm !== 0 && !p.term_ids.includes(activeTerm)) return false;
        if (activeStato !== "" && !p.stato_progetto.includes(activeStato))
          return false;
        if (q && !p.titolo.toLowerCase().includes(q)) return false;
        return true;
      });
    },

    get visibleIds() {
      return new Set(
        state.filteredProjects.slice(0, state.visibleCount).map((p) => p.id),
      );
    },

    get getItemDisplay() {
      const { projectId } = getContext();
      return state.visibleIds.has(projectId) ? "block" : "none";
    },

    get emptyDisplay() {
      return state.filteredProjects.length === 0 ? "block" : "none";
    },

    get loadMoreDisplay() {
      return state.filteredProjects.length > state.visibleCount
        ? "flex"
        : "none";
    },

    get termDescriptionDisplay() {
      return state.activeTermDescription ? "block" : "none";
    },

    get dropdownLabel() {
      if (!state.activeStato) return state.dropdownLabelDefault;
      const found = state.stati.find((s) => s.value === state.activeStato);
      return found ? found.label : state.dropdownLabelDefault;
    },

    get isTermActive() {
      const { termId } = getContext();
      return state.activeTerm === termId;
    },

    get isStatoActive() {
      const { statoValue } = getContext();
      return state.activeStato === statoValue;
    },
    get infograficaDisplay() {
      return state.activeTermInfograficaUrl ? "flex" : "none";
    },
  },

  actions: {
    setTerm() {
      const { termId } = getContext();
      state.activeTerm = termId;
      state.visibleCount = state.perPage;

      if (termId === 0) {
        state.activeTermDescription = "";
        state.activeTermInfograficaUrl = "";
      } else {
        const found = state.terms.find((t) => t.id === termId);
        state.activeTermDescription = found?.description || "";
        state.activeTermInfograficaUrl = found?.infografica_url || "";
      }

      updateURL();
    },

    setStato() {
      const { statoValue } = getContext();
      state.activeStato = statoValue;
      state.visibleCount = state.perPage;
      state.dropdownOpen = false;
    },

    setSearch(event) {
      state.searchQuery = event.target.value;
      state.visibleCount = state.perPage;
      updateURL();
    },

    toggleDropdown() {
      state.dropdownOpen = !state.dropdownOpen;
    },

    loadMore() {
      state.visibleCount += state.perPage;
    },
  },
});

// ── Funzione helper per aggiornare l'URL ──────────────────────────────────
function updateURL() {
  const params = new URLSearchParams(window.location.search);

  if (state.activeTerm === 0) {
    params.delete("categoria");
  } else {
    const found = state.terms.find((t) => t.id === state.activeTerm);
    if (found) params.set("categoria", found.slug);
  }

  if (!state.searchQuery) {
    params.delete("q");
  } else {
    params.set("q", state.searchQuery);
  }

  const newUrl = params.toString()
    ? `${window.location.pathname}?${params.toString()}`
    : window.location.pathname;

  history.pushState(null, "", newUrl);
}

// ── Inizializzazione da URL al caricamento ────────────────────────────────
const urlParams = new URLSearchParams(window.location.search);

const categoriaSlug = urlParams.get("categoria");
if (categoriaSlug) {
  const found = state.terms.find((t) => t.slug === categoriaSlug);
  if (found) {
    state.activeTerm = found.id;
    state.activeTermDescription = found.description || "";
    state.activeTermInfograficaUrl = found.infografica_url || "";
  }
}

const searchQuery = urlParams.get("q");
if (searchQuery) {
  state.searchQuery = searchQuery;
  const input = document.querySelector(".filterable-project .fp-search-input");
  if (input) input.value = searchQuery;
}

// ── Tasto indietro/avanti del browser ────────────────────────────────────
window.addEventListener("popstate", () => {
  const params = new URLSearchParams(window.location.search);

  const slug = params.get("categoria");
  if (!slug) {
    state.activeTerm = 0;
    state.activeTermDescription = "";
    state.activeTermInfograficaUrl = "";
  } else {
    const found = state.terms.find((t) => t.slug === slug);
    if (found) {
      state.activeTerm = found.id;
      state.activeTermDescription = found.description || "";
      state.activeTermInfograficaUrl = found.infografica_url || "";
    }
  }

  const q = params.get("q");
  state.searchQuery = q || "";
  state.visibleCount = state.perPage;

  const input = document.querySelector(".filterable-project .fp-search-input");
  if (input) input.value = q || "";
});
